// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__cx1dn","copy":"styles_copy__ut81p","heading":"styles_heading___Pq7C","image":"styles_image__l33hl"};